import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { IObservationFull, IRequisition } from '@project/view-models';
import { RequisitionDetailsManagerService } from '../../services/requisition-details-manager.service';
import { HcService } from '@project/services';

@Component({
  selector: 'app-session-details-patient-document',
  templateUrl: './session-details-patient-document.component.html',
  styleUrls: ['./session-details-patient-document.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionDetailsPatientDocumentComponent {
  public observations$: Observable<IObservationFull[]> = this.requisitionDetailsManagerService.observations$;
  public readonly requisition$: Observable<IRequisition> = this.requisitionDetailsManagerService.requisition$;
  selectedSubTab = 0;

  constructor(
    private requisitionDetailsManagerService: RequisitionDetailsManagerService,
    public hcService: HcService,
  ) {}
}
